import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const NotesFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                d="M14.69 1.53605C14.4166 1.25338 14.0558 1.07122 13.666 1.01905C13.5779 1.00672 13.489 1.00037 13.4 1.00005C12.9141 0.996355 12.4466 1.18552 12.1 1.52605L4.50003 9.12605V11.7261H7.10003L14.7 4.12605C14.7 4.12605 15.0068 3.78285 15.0976 3.57134C15.1884 3.35984 15.2323 3.13114 15.226 2.90105C15.2306 2.39386 15.0385 1.90461 14.69 1.53605Z"
                fill={props.color}
            />
            <Path
                d="M7.23587 2.5H3.1604L3.15591 2.50002C2.58571 2.50513 2.04032 2.73393 1.63712 3.13716C1.23393 3.54038 1.00514 4.08579 1.00002 4.656L1 13.3395L1.00004 13.3442C1.00541 13.9143 1.23424 14.4595 1.63734 14.8626C2.04044 15.2658 2.58563 15.4946 3.15569 15.5L11.8396 15.5L11.8444 15.5C12.4144 15.4946 12.9596 15.2658 13.3627 14.8626C13.7658 14.4595 13.9947 13.9143 14 13.3442V9.26379C14 8.98765 13.7762 8.76379 13.5 8.76379C13.2239 8.76379 13 8.98765 13 9.26379V13.3369C12.9966 13.6443 12.873 13.9382 12.6556 14.1555C12.4382 14.3729 12.1444 14.4966 11.8371 14.5H3.16298C2.85565 14.4966 2.56184 14.3729 2.34447 14.1555C2.1271 13.9382 2.00347 13.6443 2.00002 13.337V4.66292C2.00331 4.35553 2.12687 4.06164 2.34425 3.84424C2.56164 3.62684 2.8555 3.50329 3.16284 3.5H7.23587C7.51201 3.5 7.73587 3.27614 7.73587 3C7.73587 2.72386 7.51201 2.5 7.23587 2.5Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(NotesFilled);
